<template>
  <div class="main-ct">
    <div class="header-ct">
      <p>
        {{ $t('Gamification_Games_Carousel_Explore_Our_Top_Performing_Games') }}
      </p>
    </div>
    <div class="carousel-ct">
      <el-carousel
        trigger="click"
        :autoplay="false"
        height="410px"
        arrow="always"
      >
        <el-carousel-item v-for="game in gamesInfo" :key="game.gameName">
          <div class="carousel-item-ct">
            <div>
              <img :src="game.gameImagePath" :alt="$t(game.gameName)" />
            </div>
            <div class="description-ct">
              <p class="description-header">{{ $t(game.gameName) }}</p>
              <p class="description-paragraph">
                {{ $t(game.gameDescription) }}
              </p>
              <p class="description-improves">{{ $t(game.gameImproves) }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationGamesCarousel',
  data() {
    return {
      gamesInfo: [
        {
          gameName: 'Gamification_Games_Carousel_Thunderboard',
          gameDescription:
            'Gamification_Games_Carousel_Thunderboard_Description',
          gameImproves: 'Gamification_Games_Carousel_Thunderboard_Improves',
          // tried using the string only but didn't work
          gameImagePath: require('@/img/gamification/xp-tb-thunderboard.png')
        },
        {
          gameName: 'Gamification_Games_Carousel_Scratchcards',
          gameDescription:
            'Gamification_Games_Carousel_Scratchcards_Description',
          gameImproves: 'Gamification_Games_Carousel_Scratchcards_Improves',
          gameImagePath: require('@/img/gamification/xp-tb-scratchcards.png')
        },
        {
          gameName: 'Gamification_Games_Carousel_Wheel',
          gameDescription: 'Gamification_Games_Carousel_Wheel_Description',
          gameImproves: 'Gamification_Games_Carousel_Wheel_Improves',
          gameImagePath: require('@/img/gamification/xp-tb-wheel.png')
        },
        {
          gameName: 'Gamification_Games_Carousel_Slots',
          gameDescription: 'Gamification_Games_Carousel_Slots_Description',
          gameImproves: 'Gamification_Games_Carousel_Slots_Improves',
          gameImagePath: require('@/img/gamification/xp-tb-slots.png')
        },
        {
          gameName: 'Gamification_Games_Carousel_Bingo_Bash',
          gameDescription: 'Gamification_Games_Carousel_Bingo_Bash_Description',
          gameImproves: 'Gamification_Games_Carousel_Bingo_Bash_Improves',
          gameImagePath: require('@/img/gamification/xp-tb-bingo-bash.png')
        }
      ]
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
}

.header-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 65px 20px 65px;

  p {
    color: #5c6374;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
  }
}

.carousel-ct {
  display: flex;
  flex-direction: column;
  padding: 30px 65px 60px 65px;
}

.carousel-item-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 45px;
}

.description-ct {
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;

  .description-header {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    color: #5c6374;
  }

  .description-paragraph {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #7e8596;
  }

  .description-improves {
    font-size: 16px;
    font-style: italic;
    font-weight: 600;
    line-height: 24px;
    color: #1d87c9;
  }
}

img {
  width: 317px;
  height: 342px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationGamesCarousel.vue